export const FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_LEGACY = "legacy";
export const FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_V6 = "v6";

const LEGACY_FLAT_TAX_MATH_OPENEND_STIMULUS = {
  version: FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_LEGACY,
  groups: {
    lower: {
      taxpayers: "100,000",
      eachIncome: "$1,000",
      totalIncome: "$100 million",
      payrollShare: "100%",
      taxRate: "20%",
    },
    middle: {
      taxpayers: "100,000",
      eachIncome: "$2,000",
      totalIncome: "$200 million",
      payrollShare: "50%",
      taxRate: "30%",
    },
    higher: {
      taxpayers: "100,000",
      eachIncome: "$3,000",
      totalIncome: "$300 million",
      payrollShare: "50%",
      taxRate: "40%",
    },
  },
  preReformRevenue: "$110 million",
  correctRevenue: "$120 million",
};

const V6_FLAT_TAX_MATH_OPENEND_STIMULUS = {
  version: FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_V6,
  groups: {
    lower: {
      taxpayers: "100,000",
      eachIncome: "$1,000",
      totalIncome: "$100 million",
      payrollShare: "100%",
      taxRate: "20%",
    },
    middle: {
      taxpayers: "200,000",
      eachIncome: "$2,000",
      totalIncome: "$400 million",
      payrollShare: "50%",
      taxRate: "30%",
    },
    higher: {
      taxpayers: "20,000",
      eachIncome: "$10,000",
      totalIncome: "$200 million",
      payrollShare: "25%",
      taxRate: "40%",
    },
  },
  preReformRevenue: "$100 million",
  correctRevenue: "$110 million",
};

export function normalizeFlatTaxMathOpenendStimulusVersion(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return normalized === FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_V6
    ? FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_V6
    : FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_LEGACY;
}

export function getFlatTaxMathOpenendStimulusVersion(treatment = {}) {
  if (!treatment || typeof treatment !== "object") {
    return FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_LEGACY;
  }

  return normalizeFlatTaxMathOpenendStimulusVersion(
    treatment.stimulusVersion ?? treatment.factors?.stimulusVersion
  );
}

export function getFlatTaxMathOpenendStimulus(versionOrTreatment = {}) {
  const version =
    typeof versionOrTreatment === "string"
      ? normalizeFlatTaxMathOpenendStimulusVersion(versionOrTreatment)
      : getFlatTaxMathOpenendStimulusVersion(versionOrTreatment);

  return version === FLAT_TAX_MATH_OPENEND_STIMULUS_VERSION_V6
    ? V6_FLAT_TAX_MATH_OPENEND_STIMULUS
    : LEGACY_FLAT_TAX_MATH_OPENEND_STIMULUS;
}
